export const t10s = {
  errors: {
    userNotFound: 'User not found',
    verifierMissing: 'Recaptcha verifier not provided',
    verificationIdMissing:
      'Verification id missing. Verify phone number first.',
  },
};
